import { render, staticRenderFns } from "./plotly-graph.vue?vue&type=template&id=5dc635ea&"
import script from "./plotly-graph.vue?vue&type=script&lang=js&"
export * from "./plotly-graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports